import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { patchApiData, postApiData } from "../helpers/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { ParseError } from "../helpers/ParseError";
import { AxiosResponse } from "axios";

interface IUsePostHook {
  queryKey: string[];
  navigateURL?: string | null;
}

const useGrapesjsHook = <T extends AxiosResponse>({
  queryKey,
  navigateURL = null,
}: IUsePostHook) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  let postSuccess = false;
  let patchSuccess = false;

  const { isPending: isPatchLoading, mutateAsync: postAsync } = useMutation({
    mutationFn: postApiData,
    onSuccess: async ({ data }) => {
      postSuccess = true;
      if (navigateURL) {
        navigate(navigateURL);
      }

      if (postSuccess && patchSuccess) {
        toast.success("Updated Successfully");
      }
    },
    onError: (error, variables) => {
      const { setError } = variables;
      if (setError) {
        //@ts-ignore
        for (const key in error?.response?.data) {
          //@ts-ignore
          if (error?.response?.data.hasOwnProperty(key)) {
            setError(key, {
              type: "custom",
              //@ts-ignore
              message: error.response?.data[key],
            });
          }
        }
      }
      throw error;
    },
    onSettled: async () => {
      queryClient.invalidateQueries({
        queryKey: queryKey,
        refetchType: "active",
      });
    },
  });

  const { isPending: isPostLoading, mutateAsync: patchAsync } = useMutation({
    mutationFn: patchApiData<T>,
    onSuccess: (data) => {
      patchSuccess = true;
      toast.success("Updated successfully");
      if (navigateURL) {
        return navigate(navigateURL);
      }
      if (postSuccess && patchSuccess) {
        toast.success("Updated Successfully");
      }
      return data;
    },
    onError: (error, variables) => {
      const { setError } = variables;
      if (setError && !(error instanceof ParseError)) {
        //@ts-ignore
        for (const key in error?.response?.data) {
          //@ts-ignore
          if (error.response?.data.hasOwnProperty(key)) {
            if (setError)
              setError(key as any, {
                type: "custom",
                //@ts-ignore
                message: error?.response?.data[key],
              });
          }
        }
      }
      throw error;
    },
    onSettled: () => {
      queryClient.invalidateQueries();
    },
  });

  return {
    isPostLoading,
    isPatchLoading,
    postAsync,
    patchAsync,
  };
};

export default useGrapesjsHook;
